export const US_SECRETARY_OF_STATES = {
  ak_secretary_of_state: {
    website: 'https://www.commerce.alaska.gov/cbp/main/Search/Entities',
    name: 'Alaska Secretary of State',
  },
  al_secretary_of_state: {
    website: 'http://arc-sos.state.al.us/CGI/CORPNAME.MBR/INPUT',
    name: 'Alabama Secretary of State',
  },
  ar_secretary_of_state: {
    website: 'https://www.ark.org/corp-search/index.php?fullsite',
    name: 'Arkansas Secretary of State',
  },
  az_secretary_of_state: {
    website: 'https://ecorp.azcc.gov/EntitySearch/Index',
    name: 'Arizona Secretary of State',
  },
  ca_secretary_of_state: {
    website: 'https://bizfileonline.sos.ca.gov/search/business',
    name: 'California Secretary of State',
  },
  co_secretary_of_state: {
    website: 'https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do',
    name: 'Colorado Secretary of State',
  },
  ct_secretary_of_state: {
    website: 'https://service.ct.gov/business/s/onlinebusinesssearch?language=en_US',
    name: 'Connecticut Secretary of State',
  },
  dc_secretary_of_state: {
    website: 'https://corponline.dcra.dc.gov/Home.aspx/Landing',
    name: 'District of Columbia Secretary of State',
  },
  de_secretary_of_state: {
    website: 'https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx',
    name: 'Delaware Secretary of State',
  },
  fl_secretary_of_state: {
    website: 'https://search.sunbiz.org/Inquiry/CorporationSearch/ByName',
    name: 'Florida Secretary of State',
  },
  ga_secretary_of_state: {
    website: 'https://ecorp.sos.ga.gov/BusinessSearch',
    name: 'Georgia Secretary of State',
  },
  hi_secretary_of_state: {
    website: 'https://hbe.ehawaii.gov/documents/search.html',
    name: 'Hawaii Secretary of State',
  },
  ia_secretary_of_state: {
    website: 'https://sos.iowa.gov/search/business/search.aspx',
    name: 'Iowa Secretary of State',
  },
  id_secretary_of_state: {
    website: 'https://sosbiz.idaho.gov/search/business',
    name: 'Idaho Secretary of State',
  },
  il_secretary_of_state: {
    website: 'https://apps.ilsos.gov/businessentitysearch/',
    name: 'Illinois Secretary of State',
  },
  in_secretary_of_state: {
    website: 'https://bsd.sos.in.gov/publicbusinesssearch',
    name: 'Indiana Secretary of State',
  },
  ks_secretary_of_state: {
    website: 'https://www.sos.ks.gov/eforms/BusinessEntity/Search.aspx',
    name: 'Kansas Secretary of State',
  },
  ky_secretary_of_state: {
    website: 'https://web.sos.ky.gov/bussearchnprofile/search.aspx',
    name: 'Kentucky Secretary of State',
  },
  la_secretary_of_state: {
    website: 'https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx',
    name: 'Louisiana Secretary of State',
  },
  ma_secretary_of_state: {
    website: 'https://corp.sec.state.ma.us/corpweb/corpsearch/CorpSearch.aspx',
    name: 'Massachusetts Secretary of State',
  },
  md_secretary_of_state: {
    website: 'https://egov.maryland.gov/BusinessExpress/EntitySearch/BusinessInformation/F10429728',
    name: 'Maryland Secretary of State',
  },
  me_secretary_of_state: {
    website: 'https://apps3.web.maine.gov/nei-sos-icrs/ICRS?MainPage=x',
    name: 'Maine Secretary of State',
  },
  mi_secretary_of_state: {
    website: 'https://cofs.lara.state.mi.us/SearchApi/Search/Search',
    name: 'Michigan Secretary of State',
  },
  mn_secretary_of_state: {
    website: 'https://mblsportal.sos.state.mn.us/Business/Search',
    name: 'Minnesota Secretary of State',
  },
  mo_secretary_of_state: {
    website: 'https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx?SearchType=0',
    name: 'Missouri Secretary of State',
  },
  ms_secretary_of_state: {
    website: 'https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx',
    name: 'Mississippi Secretary of State',
  },
  mt_secretary_of_state: {
    website: 'https://biz.sosmt.gov/search/business',
    name: 'Montana Secretary of State',
  },
  nc_secretary_of_state: {
    website: 'https://www.sosnc.gov/online_services/search/by_title/_Business_Registration',
    name: 'North Carolina Secretary of State',
  },
  nd_secretary_of_state: {
    website: 'https://firststop.sos.nd.gov/search/business',
    name: 'North Dakota Secretary of State',
  },
  ne_secretary_of_state: {
    website: 'https://www.nebraska.gov/sos/corp/corpsearch.cgi',
    name: 'Nebraska Secretary of State',
  },
  nh_secretary_of_state: {
    website: 'https://quickstart.sos.nh.gov/online/BusinessInquire',
    name: 'New Hampshire Secretary of State',
  },
  nj_secretary_of_state: {
    website: 'https://www.njportal.com/DOR/businessrecords/EntityDocs/BusinessStatCopies.aspx',
    name: 'New Jersey Secretary of State',
  },
  nm_secretary_of_state: {
    website: 'https://portal.sos.state.nm.us/BFS/online/',
    name: 'New Mexico Secretary of State',
  },
  nv_secretary_of_state: {
    website: 'https://esos.nv.gov/EntitySearch/OnlineEntitySearch',
    name: 'Nevada Secretary of State',
  },
  ny_secretary_of_state: {
    website: 'https://apps.dos.ny.gov/publicInquiry/',
    name: 'New York Secretary of State',
  },
  oh_secretary_of_state: {
    website: 'https://businesssearch.ohiosos.gov/',
    name: 'Ohio Secretary of State',
  },
  ok_secretary_of_state: {
    website: 'https://www.sos.ok.gov/corp/corpInquiryFind.aspx',
    name: 'Oklahoma Secretary of State',
  },
  or_secretary_of_state: {
    website: 'https://egov.sos.state.or.us/br/pkg_web_name_srch_inq.login',
    name: 'Oregon Secretary of State',
  },
  pa_secretary_of_state: {
    website: 'https://file.dos.pa.gov/search/business',
    name: 'Pennsylvania Secretary of State',
  },
  pr_secretary_of_state: {
    website: 'https://rceweb.estado.pr.gov/en/search/',
    name: 'Puerto Rico Secretary of State',
  },
  ri_secretary_of_state: {
    website: 'https://business.sos.ri.gov/CorpWeb/CorpSearch/CorpSearch.aspx',
    name: 'Rhode Island Secretary of State',
  },
  sc_secretary_of_state: {
    website: 'https://businessfilings.sc.gov/BusinessFiling/Entity/Search',
    name: 'South Carolina Secretary of State',
  },
  sd_secretary_of_state: {
    website: 'https://sosenterprise.sd.gov/BusinessServices/Business/FilingSearch.aspx',
    name: 'South Dakota Secretary of State',
  },
  tn_secretary_of_state: {
    website: 'https://tnbear.tn.gov/Ecommerce/FilingSearch.aspx',
    name: 'Tennessee Secretary of State',
  },
  tx_secretary_of_state: {
    website: 'https://mycpa.cpa.state.tx.us/coa/Index.html',
    name: 'Texas Secretary of State',
  },
  ut_secretary_of_state: {
    website: 'https://secure.utah.gov/bes/index.html',
    name: 'Utah Secretary of State',
  },
  va_secretary_of_state: {
    website: 'https://cis.scc.virginia.gov/EntitySearch/Index',
    name: 'Virginia Secretary of State',
  },
  vi_secretary_of_state: {
    website: 'https://www.corporationsandtrademarks.vi.gov/usvi-master/',
    name: 'US Virgin Islands Office of the Lieutenant Governor',
  },
  vt_secretary_of_state: {
    website: 'https://bizfilings.vermont.gov/online/BusinessInquire',
    name: 'Vermont Secretary of State',
  },
  wa_secretary_of_state: {
    website: 'https://ccfs.sos.wa.gov/#/AdvancedSearch',
    name: 'Washington Secretary of State',
  },
  wi_secretary_of_state: {
    website: 'https://wdfi.org/apps/CorpSearch/Search.aspx',
    name: 'Wisconsin Secretary of State',
  },
  wv_secretary_of_state: {
    website: 'https://apps.wv.gov/SOS/BusinessEntitySearch/',
    name: 'West Virginia Secretary of State',
  },
  wy_secretary_of_state: {
    website: 'https://wyobiz.wyo.gov/Business/FilingSearch.aspx',
    name: 'Wyoming Secretary of State',
  },
};
export type UsSecretaryOfState = keyof typeof US_SECRETARY_OF_STATES;
